<h2>Anställningsförhållande</h2>

<spb-occupation
  [(model)]="occupation"
  [occupations]="occupations()"
/>

@if (occupation() === 'EMPLOYEE') {
  <spb-form-of-employment
    [employmentForms]="employmentForms()"
    [(model)]="employmentForm"
  />
}


<!--Employer seems to only work (be saved by API) when occupationType is as below... -->
@if (occupation() === 'EMPLOYEE') {
  <spb-employer
    [(model)]="employer"
  />
}

@if (occupation() === 'EMPLOYEE' && employmentForm() === 'FIXED_TERM') {

  <spb-date-range-select [(start)]="startDate" [(end)]="endDate"/>
} @else if (occupation() === 'EMPLOYEE' && employmentForm() === 'PERMANENT') {

  <!-- Tillsvidareanställd (Permanent Employment) Start Date -->
  <spb-date-select [(model)]="startDate"/>
}

<spb-gross-salary
  [(model)]="salary"
/>
